module.exports = __webpack_public_path__ + "img/is.357dcb1c.svg";